/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import { NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from '../../CustomAxios';
import Loading from '../components/Loading';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import swal from 'sweetalert';

import * as _ from 'lodash';
import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Chip,
  Divider as MuiDivider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { Add as AddIcon, Download } from '@mui/icons-material';
import { spacing } from '@mui/system';
import { withStyles } from '@mui/styles';
import Filter from '../components/Filter';
import { connect } from 'react-redux';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CSVLink } from 'react-csv';
import moment from 'moment';

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(job, customer, name, plate, cost, status, delivery, required, recieved, data) {
  return {
    job,
    customer,
    name,
    plate,
    cost,
    status,
    delivery,
    required,
    recieved,
    data,
  };
}

const headCells = [
  { key: 'job', alignment: 'left', label: 'Job ID' },
  { key: 'customer', alignment: 'left', label: 'Customer Name' },
  { key: 'name', alignment: 'left', label: 'Job Name' },
  { key: 'plate', alignment: 'left', label: 'Plate Quantity  T/NTB/R' },
  { key: 'category', alignment: 'left', label: 'Category' },
  { key: 'recieved', alignment: 'left', label: 'Recieved Date' },
  //   { key: "delivery", alignment: "left", label: "Delivery Address" },
  { key: 'required', alignment: 'left', label: 'Delivery Date' },
  { key: 'status', alignment: 'left', label: 'Status' },
];

const getCompanies = async (setCompanies) => {
  try {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + authData.access_token,
      },
    };
    const companydata = await axios.get(`/api/v1/${authData?.type}/ap_company`, config);
    if (companydata.data.success) {
      setCompanies(companydata.data.data.data);
    }
  } catch (e) {
    console.log(e);
  }
};

const getCustomerCompany = async (setCompany) => {
  try {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/customer_company?limit=500`,
      config
    );
    if (data.success) {
      setCompany(data.data.data);
    }
  } catch (error) { }
};

const EnhancedTableHead = (props) => {
  const {
    editPermission,
    viewPermission,
    challanPermission,
    billPermission,
    jobCostPermission,
    numSelectedJobs,
    onSelectAllJobs,
    rowCount,
    setToggle,
    permissions,
    authData
  } = props;
  const [head, setHeads] = useState(headCells);
  useEffect(() => {
    if (jobCostPermission) {
      setHeads((prev) => [
        { key: 'job', alignment: 'left', label: 'Job ID' },
        { key: 'customer', alignment: 'left', label: 'Customer Name' },
        { key: 'name', alignment: 'left', label: 'Job Name' },
        { key: 'plate', alignment: 'center', label: 'Plate Quantity T/NTB/R' },
        { key: 'cost', alignment: 'left', label: 'Job Cost' },
        { key: 'category', alignment: 'left', label: 'Category' },
        { key: 'recieved', alignment: 'left', label: 'Recieved Date' },

        { key: 'required', alignment: 'left', label: 'Delivery Date' },
        { key: 'status', alignment: 'left', label: 'Status' },
      ]);
    }
    if (challanPermission) {
      setHeads((prev) => [...prev, { id: 'edit', alignment: 'center', label: 'Challan' }]);
    }
    if (billPermission) {
      setHeads((prev) => [...prev, { id: 'edit', alignment: 'center', label: 'Bill' }]);
    }
    if (viewPermission) {
      setHeads((prev) => [...prev, { id: 'view', alignment: 'center', label: 'View' }]);
    }
    if (editPermission) {
      setHeads((prev) => [...prev, { id: 'edit_', alignment: 'center', label: 'Edit' }]);
    }
  }, []);

  return (
    <TableHead>
      <TableRow>
        {((editPermission && permissions?.includes('delete_jobs')) || authData?.type === 'super_admin') && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelectedJobs > 0 && numSelectedJobs < rowCount}
              checked={rowCount > 0 && numSelectedJobs === rowCount}
              onChange={onSelectAllJobs}
            />
          </TableCell>
        )}
        {head.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? 'none' : 'normal'}
          >
            {headCell.key === 'job' && (
              <FormGroup>
                <FormControlLabel
                  control={<Switch onChange={(e) => setToggle(e.target.checked)} />}
                  label='Show'
                />
              </FormGroup>
            )}

            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  const [companies, setCompany] = useState([]);
  const [apCompanies, setApCompanies] = useState([]);
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  useEffect(() => {
    getCompanies(setApCompanies);
    getCustomerCompany(setCompany);
  }, []);
  const navigate = useNavigate();
  // Here was 'let'
  const {
    permissions,
    chalan,
    setChalan,
    setFilter,
    setSelectedCompany,
    setStatus,
    status,
    selectedCompany,
    received_date_from,
    setReceivedDateFrom,
    received_date_to,
    setReceivedDateTo,
    apCompany,
    setApCompany,
    rows,
    notToBill,
    setNotToBill,
    setIncludeDeleted,
    includeDeleted,
    setOnSearch,
    setSearch,
    search,
    jobCostPermission,
    productionRejection,
    setProductionRejection,
    referJob,
    setReferJob,
    auths,
    challanPermission,
    paymentCompleted,
    setPaymentCompleted,
    plate,
    setPlate,
    csvPermission,
    sortByDeliveryDate,
    setSortByDeliveryDate,
    selectedJobs,
    handleDeleteSelectedJobs,
    editPermission,
    machineList,
    setApMachine,
    apMachine,
    category,
    setCategory,
    categoryList,
    docketBy,
    setDocketBy
  } = props;

  let hd = [
    { key: 'customer', alignment: 'left', label: 'Customer Name' },
    { key: 'name', alignment: 'left', label: 'Job Name' },
    { key: 'plate', alignment: 'left', label: 'Plate Quantity' },
    { key: 'ntb', alignment: 'left', label: 'NTB Quantity' },
    {
      key: 'reject',
      alignment: 'left',
      label: 'Production Rejection Quantity',
    },
    { key: 'category', alignment: 'left', label: 'Category' },
    { key: 'recieved', alignment: 'left', label: 'Recieved Date' },

    { key: 'required', alignment: 'left', label: 'Delivery Date' },
    { key: 'status', alignment: 'left', label: 'Status' },
  ];

  if (jobCostPermission) {
    hd = [
      { key: 'job', alignment: 'left', label: 'Job ID' },
      { key: 'customer', alignment: 'left', label: 'Customer Name' },
      { key: 'name', alignment: 'left', label: 'Job Name' },
      { key: 'plate', alignment: 'left', label: 'Plate Quantity' },
      { key: 'ntb', alignment: 'left', label: 'NTB Quantity' },
      {
        key: 'reject',
        alignment: 'left',
        label: 'Production Rejection Quantity',
      },

      { key: 'cost', alignment: 'left', label: 'Job Cost' },
      { key: 'category', alignment: 'left', label: 'Category' },
      { key: 'recieved', alignment: 'left', label: 'Recieved Date' },

      { key: 'required', alignment: 'left', label: 'Delivery Date' },
      { key: 'status', alignment: 'left', label: 'Status' },
    ];
  }
  if (challanPermission) {
    hd.push({
      key: 'challan',
      alignment: 'left',
      label: 'Challan Created',
    });
  }

  let rw = [];
  let detailedCsvData = [];

  rows.forEach((element, j) => {
    let quantity = 0;
    let ntb = 0;
    let reject = 0;
    for (let i = 0; i < element.data.plates.length; i++) {
      quantity += element.data.plates[i].ctp_plate_count || 0;
      if (element.data.plates[i].not_to_bill === true) {
        ntb += element.data.plates[i].ctp_plate_count || 0;
      }
      if (element.data.plates[i].production_rejection === true) {
        reject += element.data.plates[i].ctp_plate_count || 0;
      }
    }
    if (challanPermission) {
      rw.push({
        ...element,
        challan: element.data.challan_created === true ? 'YES' : 'NO',
        plate: quantity,
        ntb: ntb,
        reject: reject,
        category: element.data.category,
      });
    } else {
      rw.push({ ...element, plate: quantity, ntb: ntb, reject: reject, category: element.data.category });
    }
  });
  let timestamp = moment().format('DD-MM-YY HH:mm');

  const csvReport = {
    filename: `Jobs_${timestamp}.csv`,
    headers: hd,
    data: rw,
  };

  rows.forEach((job) => {
    if (job.data && Array.isArray(job.data.plates)) {
      job.data.plates.forEach((plate) => {
        const plateDetails = plate.plate_details || {};
        const brand = plateDetails.brand || {};
        const technology = plateDetails.technology || {};

        detailedCsvData.push({
          job_id: job.job,
          customer: job.customer,
          job_name: job.name,
          category: job.data.category || "",
          job_cost: job.cost || "",
          docket_by: job.data.docket_details.action_by_name || "",
          plate_brand: brand.name || "",
          plate_technology: technology.name || "",
          plate_dimensions: `${plateDetails.height || 0}×${plateDetails.width || 0}×${plateDetails.thickness || 0}`,
          plate_quantity: plate.ctp_plate_count || 0,
          not_to_bill: plate.not_to_bill ? "YES" : "NO",
          production_rejection: plate.production_rejection ? "YES" : "NO",
          gripper: plate.gripper || "",
          bake: plate.bake || "",
          printout: plate.printout || "",
          baking_cost: plate.baking_cost || 0,
          print_cost: plate.print_cost || 0,
          selling_cost: plate.selling_cost || 0,
          received_date: job.data.received_date ? new Date(job.data.received_date).toLocaleString('en-IN') : "",
          delivery_date: job.data.required_date ? new Date(job.data.required_date).toLocaleString('en-IN') : "",
          status: job.data.current_status,
          challan_created: job.data.challan_created ? "YES" : "NO",
        });
      });
    }
  });
  // Unified headers
  const detailedCsvHeadCells = [
    { key: "job_id", label: "Job ID" },
    { key: "customer", label: "Customer Name" },
    { key: "job_name", label: "Job Name" },
    { key: "category", label: "Category" },
    { key: "job_cost", label: "Job Cost" },
    { key: "docket_by", label: "Docket By" },
    { key: "plate_brand", label: "Plate Brand" },
    { key: "plate_technology", label: "Plate Technology" },
    { key: "plate_dimensions", label: "Dimensions (H×W×T mm)" },
    { key: "plate_quantity", label: "Plate Quantity" },
    { key: "not_to_bill", label: "Not To Bill" },
    { key: "production_rejection", label: "Production Rejection" },
    { key: "gripper", label: "Gripper" },
    { key: "bake", label: "Bake" },
    { key: "printout", label: "Printout" },
    { key: "baking_cost", label: "Baking Cost" },
    { key: "print_cost", label: "Print Cost" },
    { key: "selling_cost", label: "Selling Cost" },
    { key: "received_date", label: "Received Date" },
    { key: "delivery_date", label: "Delivery Date" },
    { key: "status", label: "Status" },
    { key: "challan_created", label: "Challan Created" },
  ];

  const detailedCsvReport = {
    filename: `Detailed_Jobs_${timestamp}.csv`,
    headers: detailedCsvHeadCells,
    data: detailedCsvData,
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setOnSearch(true);
      }}
    >
      <Toolbar>
        <ToolbarTitle>
          <Typography variant='h6' id='tableTitle'>
            Jobs
          </Typography>
        </ToolbarTitle>
        <Spacer />

        <>
          {csvPermission && (
            <CSVLink
              data={detailedCsvData}
              headers={detailedCsvHeadCells}
              filename={`Detailed_Jobs_${timestamp}.csv`}
              style={{ color: "green", textDecoration: "none" }}
            >
              <Button
                variant="outlined"
                endIcon={<Download />}
                sx={{ width: "140px" }}
              >
                Detailed CSV
              </Button>
            </CSVLink>

          )}
          {csvPermission && (
            <CSVLink style={{ color: 'green', textDecoration: 'none' }} {...csvReport}>
              <Button variant='outlined' sx={{ ml: 2, mr: 2 }} endIcon={<Download />}>
                CSV
              </Button>
            </CSVLink>
          )}
        </>
        <TextField
          value={search}
          size='small'
          style={{ width: '100%', marginRight: 5 }}
          label='Search'
          placeholder='Job Name / Job ID'
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button type='submit' endIcon={<SearchIcon />} style={{ width: '20%' }} variant='contained'>
          Search
        </Button>

        <div>
          <Filter
            setFilter={setFilter}
            chalan={chalan}
            setChalan={setChalan}
            status={status}
            selectedCompany={selectedCompany}
            setStatus={setStatus}
            setSelectedCompany={setSelectedCompany}
            companies={companies}
            received_date_from={received_date_from}
            setReceivedDateFrom={setReceivedDateFrom}
            received_date_to={received_date_to}
            setReceivedDateTo={setReceivedDateTo}
            apCompanies={apCompanies}
            apCompany={apCompany}
            setApCompany={setApCompany}
            notToBill={notToBill}
            setNotToBill={setNotToBill}
            productionRejection={productionRejection}
            setProductionRejection={setProductionRejection}
            referJob={referJob}
            setReferJob={setReferJob}
            jobs={rows}
            user={auths}
            paymentCompleted={paymentCompleted}
            setPaymentCompleted={setPaymentCompleted}
            plate={plate}
            setPlate={setPlate}
            sortByDeliveryDate={sortByDeliveryDate}
            setSortByDeliveryDate={setSortByDeliveryDate}
            includeDeleted={includeDeleted}
            setIncludeDeleted={setIncludeDeleted}
            machineList={machineList}
            setApMachine={setApMachine}
            apMachine={apMachine}
            category={category}
            setCategory={setCategory}
            categoryList={categoryList}
            docketBy={docketBy}
            setDocketBy={setDocketBy}
          />
        </div>
        {editPermission && selectedJobs.length > 0 && (
          <Tooltip title="Delete selected jobs">
            <IconButton
              onClick={handleDeleteSelectedJobs}
              color="error"
              size="large"
              sx={{ ml: 2 }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
        <div>
          {authData?.type === 'customer_user' && permissions.includes('request_new_job') && (
            <Tooltip title='Request Job'>
              <IconButton aria-label='Request Job' size='large'>
                <AddIcon onClick={() => navigate('/dashboard/jobs/request')} />
              </IconButton>
            </Tooltip>
          )}

          {authData?.type === 'ap_user' && permissions.includes('create_new_job') && (
            <Tooltip title='Create Job'>
              <IconButton aria-label='Create Job' size='large'>
                <AddIcon onClick={() => navigate('/dashboard/jobs/create-job')} />
              </IconButton>
            </Tooltip>
          )}

          {authData?.type === 'super_admin' && (
            <Tooltip title='Create Job'>
              <IconButton aria-label='Create Job' size='large'>
                <AddIcon onClick={() => navigate('/dashboard/jobs/create-job')} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </Toolbar>
    </form>
  );
};

function EnhancedTable({
  chalan,
  permissions,
  setFilter,
  setChalan,
  rows,
  selectedCompany,
  status,
  setSelectedCompany,
  setStatus,
  received_date_from,
  setReceivedDateFrom,
  received_date_to,
  setReceivedDateTo,
  editPermission,
  viewPermission,
  apCompany,
  setApCompany,
  billPermission,
  challanPermission,
  search,
  setSearch,
  notToBill,
  setNotToBill,
  setIncludeDeleted,
  includeDeleted,
  setOnSearch,
  jobCostPermission,

  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  productionRejection,
  setProductionRejection,
  referJob,
  setReferJob,
  auths,
  paymentCompleted,
  setPaymentCompleted,
  plate,
  setPlate,
  csvPermission,
  sortByDeliveryDate,
  setSortByDeliveryDate,
  setLoader,
  machineList,
  setApMachine,
  apMachine,
  category,
  setCategory,
  categoryList,
  docketBy,
  setDocketBy
}) {
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [err, setErr] = useState('');
  const navigate = useNavigate();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('customer');
  const [selected, setSelected] = React.useState([]);
  const [toggle, setToggle] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleSelectAllJobs = (event) => {
    if (event.target.checked) {
      const newSelectedJobs = rows.map((row) => row.data._id);
      setSelectedJobs(newSelectedJobs);
      return;
    }
    setSelectedJobs([]);
  };

  const deleteMultipleJobs = async (ids) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };

      // Update to match your API endpoint
      const { data } = await axios.delete(
        `/api/v1/${authData?.type}/jobs/delete`,
        {
          data: { job_ids: ids },
          ...config
        }
      );

      if (data.success) {
        setMessage("Job Operation Successfull");
        setFilter(true);
        setLoader(false);
        // setSuccess(true);
        return true;
      }
    } catch (e) {
      setLoader(false);
      console.log(e);
      setErr(e?.response?.data?.error || e?.message || e?.response);
      // setSuccess(false);
      snackRef.current?.click();
      return false;
    }
  };

  const handleSelectSingleJob = (event, id) => {
    const selectedIndex = selectedJobs.indexOf(id);
    let newSelectedJobs = [];

    if (selectedIndex === -1) {
      newSelectedJobs = newSelectedJobs.concat(selectedJobs, id);
    } else {
      newSelectedJobs = selectedJobs.filter((jobId) => jobId !== id);
    }
    setSelectedJobs(newSelectedJobs);
  };

  // ---- UPDATED: Front‑end validation for challan‑created jobs ----
  const handleDeleteSelectedJobs = () => {
    if (!selectedJobs.length) return;

    const jobsWithChallan = rows
      .filter(row => selectedJobs.includes(row.data._id) && row.data.challan_created)
      .map(row => row.job); // collect job IDs for a more detailed message

    if (jobsWithChallan.length > 0) {
      swal({
        title: 'Cannot Delete',
        text: `Some selected jobs have an associated challan and cannot be deleted.`,
        icon: 'error',
        button: 'OK',
      });
      setSelectedJobs([]); // clear selection after error
      return;
    }

    swal({
      title: 'Are you sure?',
      text: 'You want to delete/restore the jobs',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((res) => {
      if (res) {
        deleteMultipleJobs(selectedJobs);
      }
      setSelectedJobs([]);
    });
  };
  // ----------------------------------------------------------------

  useEffect(() => {
    if (location?.state?.success) {
      setErr('');
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  let plateSum = 0;
  let jobCostSum = 0;
  let ntbSum = 0;
  let rejectSum = 0;

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: 'none' }}
        onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity='error'>
            {err}
          </Alert>
        ) : (
          <Alert mt={2} mb={4} severity='success'>
            {message}
          </Alert>
        )}
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar
          setFilter={setFilter}
          setOnSearch={setOnSearch}
          search={search}
          setSearch={setSearch}
          chalan={chalan}
          setChalan={setChalan}
          selectedCompany={selectedCompany}
          status={status}
          setSelectedCompany={setSelectedCompany}
          setStatus={setStatus}
          numSelected={selected.length}
          received_date_from={received_date_from}
          setReceivedDateFrom={setReceivedDateFrom}
          received_date_to={received_date_to}
          setReceivedDateTo={setReceivedDateTo}
          apCompany={apCompany}
          setApCompany={setApCompany}
          rows={rows}
          notToBill={notToBill}
          setNotToBill={setNotToBill}
          permissions={permissions}
          jobCostPermission={jobCostPermission}
          challanPermission={challanPermission}
          productionRejection={productionRejection}
          setProductionRejection={setProductionRejection}
          referJob={referJob}
          setReferJob={setReferJob}
          auths={auths}
          paymentCompleted={paymentCompleted}
          setPaymentCompleted={setPaymentCompleted}
          plate={plate}
          setPlate={setPlate}
          csvPermission={csvPermission}
          sortByDeliveryDate={sortByDeliveryDate}
          setSortByDeliveryDate={setSortByDeliveryDate}
          includeDeleted={includeDeleted}
          setIncludeDeleted={setIncludeDeleted}
          selectedJobs={selectedJobs}
          handleDeleteSelectedJobs={handleDeleteSelectedJobs}
          editPermission={editPermission}
          machineList={machineList}
          setApMachine={setApMachine}
          apMachine={apMachine}
          category={category}
          setCategory={setCategory}
          categoryList={categoryList}
          docketBy={docketBy}
          setDocketBy={setDocketBy}
        />
        <StyledTableContainer>
          <Table aria-labelledby='tableTitle' size={'small'} aria-label='enhanced table'>
            <EnhancedTableHead
              permissions={permissions}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              editPermission={editPermission}
              viewPermission={viewPermission}
              billPermission={billPermission}
              challanPermission={challanPermission}
              jobCostPermission={jobCostPermission}
              setToggle={setToggle}
              numSelectedJobs={selectedJobs.length}
              onSelectAllJobs={handleSelectAllJobs}
              authData={authData}
            />
            <TableBody>
              {rows.map((row, index) => {
                const isJobSelected = selectedJobs.includes(row.data._id);
                let quantity = 0;
                let ntb = 0;
                let reject = 0;
                let jobCost = 0;
                for (let i = 0; i < row.data.plates.length; i++) {
                  const total_print_cost =
                    row.data.plates[i].print_cost * row.data.plates[i].printout;
                  const total_selling_cost =
                    row.data.plates[i].selling_cost * row.data.plates[i].ctp_plate_count;
                  const total_baking_cost =
                    row.data.plates[i].baking_cost * row.data.plates[i].bake;
                  jobCost += total_print_cost + total_selling_cost + total_baking_cost;
                  quantity += row.data.plates[i].ctp_plate_count || 0;
                  if (row.data.plates[i].not_to_bill === true) {
                    ntb += row.data.plates[i].ctp_plate_count || 0;
                  }
                  if (row.data.plates[i].production_rejection === true) {
                    reject += row.data.plates[i].ctp_plate_count || 0;
                  }
                }

                row.cost = jobCost;
                plateSum += quantity;
                jobCostSum += row.cost;
                ntbSum += ntb;
                rejectSum += reject;
                let flag = 0;
                row.data.plates.map((pl) => {
                  if (pl.bake) {
                    flag = 1;
                  }
                });
                let job_id = '';
                if (!toggle) {
                  if (row.job.includes('-')) {
                    let job1 = row.job.split('J');
                    let job2 = row.job.split('-');
                    job_id = job1[0] + 'J-' + job2[1];
                  } else {
                    job_id = row.job;
                  }
                } else {
                  job_id = row.job;
                }

                return (
                  <TableRow key={`${row.id}-${index}`}
                    style={{
                      backgroundColor: row?.data?.is_deleted ? "#eeaa9c" : "#fff",
                    }}>
                    {((editPermission && permissions?.includes('delete_jobs')) || authData?.type === 'super_admin') && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isJobSelected}
                          onChange={(event) => handleSelectSingleJob(event, row.data._id)}
                        />
                      </TableCell>
                    )}
                    <TableCell align='left'>{job_id}</TableCell>
                    <TableCell align='left'>{row.customer}</TableCell>
                    <TableCell align='left'>{row.name}</TableCell>
                    <TableCell
                      style={{
                        backgroundColor: flag ? '#d5e7ab' : null,
                        color: flag ? '#000' : '#000',
                        border: flag ? '1px solid #fff' : null,
                      }}
                      align='center'
                    >
                      {quantity + '/' + ntb + '/' + reject}
                    </TableCell>
                    {jobCostPermission && <TableCell align='center'>{row.cost}</TableCell>}
                    <TableCell align='left'>
                      <Chip
                        label={_.upperCase(row?.data?.category)}
                        style={{
                          fontSize: '12px',
                          color: '#FFF',
                          background:
                            row?.data?.category === 'Commercial'
                              ? '#000000'
                              : row?.data?.category === 'Web'
                                ? 'red'
                                : row?.data?.category === 'Semi-Packaging'
                                  ? '#73AE05'
                                  : row?.data?.category === 'Packaging'
                                    ? '#FFC300'
                                    : row?.data?.category === 'Other'
                                      ? '#8124F9'
                                      : '#F905CC',
                          borderColor:
                            row?.data?.category === 'Commercial'
                              ? '#000000'
                              : row?.data?.category === 'Web'
                                ? 'red'
                                : row?.data?.category === 'Semi-Packaging'
                                  ? '#73AE05'
                                  : row?.data?.category === 'Packaging'
                                    ? '#FFC300'
                                    : row?.data?.category === 'Other'
                                      ? '#8124F9'
                                      : '#F905CC',
                        }}
                        variant='filled'
                        size='small'
                        sx={{ borderRadius: '20px' }}
                      />
                    </TableCell>
                    <TableCell align='left'>
                      {new Date(row.recieved).toLocaleString('en-IN')}
                    </TableCell>
                    {/* <TableCell align="left">{row.delivery}</TableCell> */}
                    <TableCell align='left'>
                      {new Date(row?.required).toLocaleString('en-IN')}
                      {/* {row?.required.toString()} */}
                    </TableCell>
                    <TableCell align='left'>
                      <Chip
                        label={_.upperCase(row.status)}
                        style={{
                          fontSize: '12px',
                          color: '#FFF',
                          background:
                            row.status === 'new'
                              ? '#000000'
                              : row.status === 'studio'
                                ? 'red'
                                : row.status === 'ctp'
                                  ? '#73AE05'
                                  : row.status === 'ctp_impose'
                                    ? '#FFC300'
                                    : row.status === 'delivery'
                                      ? '#8124F9'
                                      : row.status === 'customer_accept'
                                        ? '#7E7D7A'
                                        : row.status === 'payment'
                                          ? '#0CA5A9'
                                          : '#F905CC',
                          borderColor:
                            row.status === 'new'
                              ? '#000000'
                              : row.status === 'studio'
                                ? 'red'
                                : row.status === 'ctp'
                                  ? '#73AE05'
                                  : row.status === 'ctp_impose'
                                    ? '#FFC300'
                                    : row.status === 'delivery'
                                      ? '#8124F9'
                                      : row.status === 'customer_accept'
                                        ? '#7E7D7A'
                                        : row.status === 'payment'
                                          ? '#0CA5A9'
                                          : '#F905CC',
                        }}
                        variant='filled'
                        size='small'
                        sx={{ borderRadius: '20px' }}
                      />
                    </TableCell>
                    {challanPermission ? (
                      <TableCell align='center'>
                        {row.data.associated_challan ? (
                          <VisibilityIcon
                            style={{ cursor: 'pointer', color: 'darkblue' }}
                            onClick={() =>
                              navigate(
                                `/dashboard/challan/challan-details/${row.data.associated_challan}`
                              )
                            }
                          />
                        ) : (
                          <VisibilityOffOutlinedIcon style={{ color: 'darkblue' }} />
                        )}
                      </TableCell>
                    ) : null}
                    {billPermission ? (
                      <TableCell align='center'>
                        {row?.data?.associated_bill ? (
                          <VisibilityIcon
                            style={{ cursor: 'pointer', color: 'black' }}
                            onClick={() =>
                              navigate(`/dashboard/bill/bill-details/${row.data.associated_bill}`)
                            }
                          />
                        ) : (
                          <VisibilityOffOutlinedIcon style={{ color: 'black' }} />
                        )}
                      </TableCell>
                    ) : null}
                    {viewPermission ? (
                      <TableCell align='center'>
                        <VisibilityIcon
                          style={{ cursor: 'pointer', color: 'green' }}
                          onClick={() =>
                            navigate(`/dashboard/jobs/job-details/${row.data._id}`, {
                              state: { job: row.data },
                            })
                          }
                        />
                      </TableCell>
                    ) : null}
                    {editPermission ? (
                      <TableCell align='center'>
                        <EditIcon
                          style={{ cursor: 'pointer', color: 'red' }}
                          onClick={() => {
                            if (row.data.challan_created && authData.type !== 'super_admin') {
                              setErr('Challan is already created for this job.');
                              snackRef.current.click();
                            } else {
                              navigate(`/dashboard/jobs/edit-job/${row.data._id}`, {
                                state: { job: row.data },
                              });
                            }
                          }}
                        />
                      </TableCell>
                    ) : null}
                  </TableRow>
                );
              })}
              {rows.length ? (
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align='center'>{plateSum + '/' + ntbSum + '/' + rejectSum}</TableCell>
                  {jobCostPermission && <TableCell align='center'>{jobCostSum}</TableCell>}
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  {viewPermission ? <TableCell></TableCell> : null}
                  {editPermission ? <TableCell></TableCell> : null}
                </TableRow>
              ) : null}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 50, 100, 250]}
          component='div'
          count={total_results}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function AllJobs({ auths }) {
  const location = useLocation();
  const navigate = useNavigate();
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);

  const [editPermission, setEditPermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);

  const [billPermission, setBillPermission] = useState(false);
  const [challanPermission, setChallanPermission] = useState(false);

  const [jobCostPermission, setJobCostPermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);

  // Filter and Search params
  const [searchParams, setSearchParams] = useSearchParams();

  const [search, setSearch] = useState(searchParams.get('search_keyword') || '');
  const [notToBill, setNotToBill] = useState(searchParams.get('not_to_bill') || '');
  const [productionRejection, setProductionRejection] = useState(
    searchParams.get('production_rejection') || ''
  );
  const [docketBy, setDocketBy] = useState(searchParams.get('docket_by') || '');
  const [selectedCompany, setSelectedCompany] = useState(
    searchParams.get('customer_company_id') || ''
  );
  const [received_date_from, setReceivedDateFrom] = useState(
    searchParams.get('received_from') || ''
  );
  const [received_date_to, setReceivedDateTo] = useState(searchParams.get('received_to') || '');
  const [apCompany, setApCompany] = useState(searchParams.get('ap_company_id') || '');
  const [referJob, setReferJob] = useState(searchParams.get('refer_job') || '');
  const [chalan, setChalan] = useState(searchParams.get('challan_created') || '');
  const [status, setStatus] = useState(searchParams.get('current_status') || '');
  const [sortByDeliveryDate, setSortByDeliveryDate] = useState(searchParams.get('delivery_date') || false);
  const [paymentCompleted, setPaymentCompleted] = useState(
    searchParams.get('payment_completed') || ''
  );
  const [includeDeleted, setIncludeDeleted] = useState(
    searchParams.get('include_deleted') === 'YES' ? true : false
  );
  const [apMachine, setApMachine] = useState(searchParams.get('ap_machine') || '');
  const [plate, setPlate] = useState(searchParams.get('plate') || '');

  const [filter, setFilter] = useState(true);
  const [onSearch, setOnSearch] = useState(false);

  const [page, setPage] = React.useState(
    searchParams.get('page') ? Number(searchParams.get('page')) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get('limit') ? Number(searchParams.get('limit')) : 25
  );
  const [total, setTotal] = useState(0);
  const [machineList, setMachineList] = useState([]);
  const categoryList = ["Commercial", "Web", "Semi-Packaging", "Packaging", "Other"];
  const [category, setCategory] = useState(searchParams.get('category') || '');

  const updateCategory = (newCategory) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (newCategory) {
      newSearchParams.set('category', newCategory);
    } else {
      newSearchParams.delete('category');
    }
    setSearchParams(newSearchParams);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeParams(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
    changeParams(0, newLimit);
  };

  const changeParams = (queryPage, queryLimit) => {
    const query = new URLSearchParams();

    if (apCompany) query.set('ap_company_id', apCompany);
    if (selectedCompany) query.set('customer_company_id', selectedCompany);
    if (chalan) query.set('challan_created', chalan);
    if (received_date_from) query.set('received_from', received_date_from);
    if (received_date_to) query.set('received_to', received_date_to);
    if (search) query.set('search_keyword', search);
    if (notToBill) query.set('not_to_bill', notToBill);
    if (status) query.set('status', status);
    if (productionRejection) query.set('production_rejection', productionRejection);
    if (referJob) query.set('refer_job', referJob);
    if (paymentCompleted) query.set('payment_completed', paymentCompleted);
    if (plate) query.set('plate', plate);
    if (includeDeleted) query.set('include_deleted', includeDeleted ? "YES" : "NO");
    if (apMachine) query.set('ap_machine', apMachine);
    if (category) query.set('category', category);
    if (includeDeleted) {
      query.set('include_deleted', "YES");
    }
    if (docketBy) query.set('docket_by', docketBy);


    query.set('page', queryPage);
    query.set('limit', queryLimit);
    query.set('delivery_date', sortByDeliveryDate);

    navigate(`/dashboard/jobs?${query.toString()}`, { replace: true });

    getAllJobs(
      auths?.user?.customer_company?._id,
      selectedCompany || '',
      status || '',
      chalan || null,
      received_date_from || '',
      received_date_to || '',
      apCompany || '',
      '',
      notToBill || '',
      queryPage,
      queryLimit,
      productionRejection || '',
      referJob || '',
      paymentCompleted,
      plate || '',
      includeDeleted,
      apMachine,
      category,
      docketBy
    );
  };

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    if (
      [
        'view_ap_company_list',
        'view_customer_company_list',
        'view_job_details',
        'view_ap_user_list',
        'view_customer_company_user_list',
        'customer_company_plate_list_view',
        'view_plate_list',
        'edit_job_details',
      ].every((k) => auths?.user?.role?.permissions.includes(k)) ||
      authData?.type === 'super_admin'
    ) {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('view_job_details') ||
      authData?.type === 'super_admin'
    ) {
      setViewPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('view_challan_details') ||
      authData?.type === 'super_admin'
    ) {
      setChallanPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('view_bill_details') ||
      authData?.type === 'super_admin'
    ) {
      setBillPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('view_job_cost') ||
      authData?.type === 'super_admin'
    ) {
      setJobCostPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes('download_csv') ||
      authData?.type === 'super_admin'
    ) {
      setCsvPermission(true);
    }
  }, [auths.user]);

  // fetch jobs
  useEffect(() => {
    const id = auths?.user?.customer_company?._id;
    if (filter || onSearch) {
      navigate(
        `/dashboard/jobs?customer_company_id=${selectedCompany}&ap_company_id=${apCompany}&plate=${plate}&payment_completed=${paymentCompleted}&search_keyword=${search}&current_status=${status}&received_from=${received_date_from}&received_to=${received_date_to}&challan_created=${chalan}&not_to_bill=${notToBill}&page=${page}&limit=${rowsPerPage}&production_rejection=${productionRejection}&refer_job=${referJob}&delivery_date=${sortByDeliveryDate}&include_deleted=${includeDeleted ? "YES" : "NO"}&ap_machine=${apMachine}&category=${category}`,
        { replace: true }
      );

      getAllJobs(
        id,
        selectedCompany,
        status,
        chalan,
        received_date_from,
        received_date_to,
        apCompany,
        '',
        notToBill,
        page,
        rowsPerPage,
        productionRejection,
        referJob,
        paymentCompleted,
        plate,
        includeDeleted,
        apMachine,
        category,
        docketBy
      );
      setFilter(false);
      setOnSearch(false);
    }
  }, [filter, onSearch]);

  //fetch machine list
  useEffect(() => {
    const getMachineList = async () => {
      try {
        const authData = JSON.parse(localStorage.getItem('AuthData'));
        const config = {
          headers: {
            Authorization: 'Bearer ' + authData?.access_token,
          },
        };
        const { data } = await axios.get(`/api/v1/${authData.type}/machine?page=1&limit=500`, config);
        if (data.success) {
          setMachineList(data.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    };
    getMachineList();
  }, []);

  const getAllJobs = async (
    id,
    company,
    status,
    chalan,
    received_date_from,
    recieved_date_to,
    apCompany,
    challan_id,
    not_to_bill,
    page,
    rowsPerPage,
    production_rejection,
    refer_job,
    payment_completed,
    plt,
    includeDeleted,
    auths,
    category,
    docket_by
  ) => {
    setLoader(true);
    try {
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData?.access_token,
        },
      };

      let ch = '';
      let url = '';
      if (chalan === null) {
        ch = '';
      } else if (chalan === true || chalan === 'true') {
        ch = 'YES';
      } else if (chalan === false || chalan === 'false') {
        ch = 'NO';
      }
      let pc = '';

      if (payment_completed === true || payment_completed === 'true') {
        pc = 'YES';
      } else if (payment_completed === false || payment_completed === 'false') {
        pc = 'NO';
      } else {
        pc = '';
      }
      if (docket_by) {
        url += `&docket_by=${docket_by}`;
      }
      const category = searchParams.get('category') || '';

      if (authData?.type === 'customer_user') {
        url = `/api/v1/${authData?.type
          }/${id}/jobs?challan_id=${challan_id}&refer_job=${refer_job}&search_keyword=${search}&payment_completed=${pc}&customer_company_id=${company}&current_status=${status}&challan_created=${ch}&received_date_from=${received_date_from}&received_date_to=${recieved_date_to}&ap_company_id=${apCompany}&not_to_bill=${not_to_bill}&production_rejection=${production_rejection}&page=${page + 1
          }&limit=${rowsPerPage}&include_deleted=${includeDeleted ? "YES" : "NO"}&ap_machine=${apMachine}&category=${category}&docket_by=${docket_by}`;
      } else {
        url = `/api/v1/${authData?.type
          }/jobs?challan_id=${challan_id}&refer_job=${refer_job}&search_keyword=${search}&payment_completed=${pc}&plate=${plt}&customer_company_id=${company}&current_status=${status}&challan_created=${ch}&received_date_from=${received_date_from}&received_date_to=${recieved_date_to}&ap_company_id=${apCompany}&not_to_bill=${not_to_bill}&production_rejection=${production_rejection}&page=${page + 1
          }&limit=${rowsPerPage}&sortByDeliveryDate=${sortByDeliveryDate}&include_deleted=${includeDeleted ? "YES" : "NO"}&ap_machine=${apMachine}&category=${category}&docket_by=${docket_by}`;
      }
      const { data } = await axios.get(url, config);
      let rows = [];
      if (data.success) {
        const jobs = data.data.data;
        setTotal(data.data.metadata.total_results);
        jobs.map((job) => {
          // let reqDate = new Date(job?.required_date);
          // let recDate = new Date(job?.received_date);

          rows.push(
            createData(
              job.job_id,
              job.customer_company.name,
              job.name,
              job.plates.length,
              job.job_total_cost,
              job.current_status,
              `${job?.delivery?.address_line_one}, ${job?.delivery?.address_line_two}, ${job?.delivery?.city}, ${job?.delivery?.state}, ${job?.delivery?.pincode}, India`,
              job?.required_date,
              job?.received_date,
              job
            )
          );
        });
        setRows(rows);
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);
      // alert(e);
      console.log(e);
    }
  };

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title='Alpha Plus' />

        <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
          <Grid item>
            <Typography
              variant='h4'
              gutterBottom
              display='inline'
              sx={{ fontWeight: 600 }}
              color='primary'
            >
              ALL JOBS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label='Breadcrumb' mt={2}>
              <Link component={NavLink} to='/dashboard/tasks'>
                Dashboard
              </Link>
              <Typography> All Jobs</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              setOnSearch={setOnSearch}
              search={search}
              setSearch={setSearch}
              chalan={chalan}
              setFilter={setFilter}
              setChalan={setChalan}
              status={status}
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
              setStatus={setStatus}
              rows={rows}
              received_date_from={received_date_from}
              setReceivedDateFrom={setReceivedDateFrom}
              received_date_to={received_date_to}
              setReceivedDateTo={setReceivedDateTo}
              editPermission={editPermission}
              viewPermission={viewPermission}
              setApCompany={setApCompany}
              apCompany={apCompany}
              billPermission={billPermission}
              jobCostPermission={jobCostPermission}
              challanPermission={challanPermission}
              notToBill={notToBill}
              setNotToBill={setNotToBill}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
              permissions={auths?.user?.role?.permissions || []}
              productionRejection={productionRejection}
              setProductionRejection={setProductionRejection}
              referJob={referJob}
              setReferJob={setReferJob}
              auths={auths}
              paymentCompleted={paymentCompleted}
              setPaymentCompleted={setPaymentCompleted}
              plate={plate}
              setPlate={setPlate}
              csvPermission={csvPermission}
              sortByDeliveryDate={sortByDeliveryDate}
              setSortByDeliveryDate={setSortByDeliveryDate}
              includeDeleted={includeDeleted}
              setIncludeDeleted={setIncludeDeleted}
              setLoader={setLoader}
              machineList={machineList}
              setApMachine={setApMachine}
              apMachine={apMachine}
              category={searchParams.get('category') || ''}
              setCategory={updateCategory}
              categoryList={categoryList}
              docketBy={docketBy}
              setDocketBy={setDocketBy}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(AllJobs);
